export function increment(n) {
    if (n === void 0) { n = 0; }
    return n + 1;
}
export function decrement(n) {
    if (n === void 0) { n = 0; }
    return n - 1;
}
